export default __webpack_public_path__ + "static/img55h-8f18afc9f8be4b676d477be20b164d13.jpg";